import { render, staticRenderFns } from "./TopBarItem.vue?vue&type=template&id=ab637908&scoped=true"
import script from "./TopBarItem.vue?vue&type=script&lang=js"
export * from "./TopBarItem.vue?vue&type=script&lang=js"
import style0 from "./TopBarItem.vue?vue&type=style&index=0&id=ab637908&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab637908",
  null
  
)

export default component.exports